import { render, staticRenderFns } from "./DeductionsChange.vue?vue&type=template&id=83bdeee6&scoped=true&"
import script from "./DeductionsChange.vue?vue&type=script&lang=js&"
export * from "./DeductionsChange.vue?vue&type=script&lang=js&"
import style0 from "./DeductionsChange.vue?vue&type=style&index=0&id=83bdeee6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83bdeee6",
  null
  
)

export default component.exports